import { useTheme } from "@hooks/useTheme";

const CustomInput = ({
  type = "text",
  value,
  onChange,
  placeholder,
  className,
  size = "md",
  disabled = false,
  readOnly = false,
  onClick,
  style,
  onFocus,
  onBlur,
  ...props
}) => {
  const { colors } = useTheme();

  // Size configurations
  const sizeConfigs = {
    xs: {
      height: "1.5rem",
      fontSize: "0.75rem",
      padding: "0px 0.5rem",
      borderRadius: "0.25rem",
    },
    sm: {
      height: "2rem",
      fontSize: "0.875rem",
      padding: "0px 0.625rem",
      borderRadius: "0.5rem",
    },
    md: {
      height: "2.5rem",
      fontSize: "0.875rem",
      padding: "0px 0.75rem",
      borderRadius: "0.5rem",
    },
    lg: {
      height: "3rem",
      fontSize: "1.125rem",
      padding: "0px 1rem",
      borderRadius: "0.5rem",
    },
    xl: {
      height: "3.5rem",
      fontSize: "1.25rem",
      padding: "0px 1.25rem",
      borderRadius: "0.75rem",
    },
  };

  const currentSize = sizeConfigs[size] || sizeConfigs.md;

  const baseClasses = [
    "w-full border focus:outline-none transition-colors truncate",
    colors.borderPrimary,
    colors.bgInput,
    colors.textPrimary,
    disabled ? "opacity-50 cursor-not-allowed" : "",
    readOnly && onClick ? "cursor-pointer" : "",
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  const inputStyles = {
    height: currentSize.height,
    fontSize: currentSize.fontSize,
    padding: currentSize.padding,
    borderRadius: currentSize.borderRadius,
    ...style,
  };

  // Handle focus border color via CSS-in-JS
  const handleFocus = (e) => {
    e.target.style.borderColor = colors.borderActiveColor;
    if (onFocus) onFocus(e);
  };

  const handleBlur = (e) => {
    e.target.style.borderColor = '';
    if (onBlur) onBlur(e);
  };

  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      onClick={onClick}
      className={baseClasses}
      style={inputStyles}
      onFocus={handleFocus}
      onBlur={handleBlur}
      {...props}
    />
  );
};

export default CustomInput;
